import React from 'react';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import CommonProductList from '../../common/CommonProductlist';

const AddeProductPage = () => {
	return (
		<PageWrapper>
			<Page container='fluid'>
				<CommonProductList isFluid />
			</Page>
		</PageWrapper>
	);
};

export default AddeProductPage;
